import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
/**
 *
 * @param props
 */
var ProgressBarComp = function (props) {
    return (React.createElement("div", { className: "scl-a-loading scl-h-color--contrast-tertiary scl-h-background\n            ".concat(props.init ? "scl-a-loading--init"
            : "") },
        React.createElement("div", { className: "scl-a-loading__bar scl-h-color--brand-accent scl-h-background scl-a-loading__bar--active", style: { width: props.percentage.toString() + "%" } })));
};
/**
 *
 */
export var ProgressBar = asThemeConsumer(ProgressBarComp);
